import { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Pagination from 'react-bootstrap/Pagination';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { BsPencilSquare, BsFillTrashFill } from 'react-icons/bs';
import { $get, $put, $delete } from './store/api';

function Felhasznalok() {
  const [users, setUsers] = useState({});
  const [page, setPage] = useState(1);
  const [filterNev, setFilterNev] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [modal, setModal] = useState(null); // null = closed, {} = new, {id,...} = edit

  const load = async () => {
    const res = await $get('users', {
      page,
      ...(filterNev   && { Nev:   filterNev }),
      ...(filterEmail && { Email: filterEmail }),
    });
    setUsers(res?.data || {});
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [page, filterNev, filterEmail]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const Nev    = document.getElementById('modal-Nev').value;
    const Email  = document.getElementById('modal-Email').value;
    const Jelszo = document.getElementById('modal-Jelszo').value;
    const obj = { Nev, Email, ...(Jelszo && { Jelszo }) };
    if (modal?.id) {
      await $put('users/' + modal.id, obj);
    } else {
      await $put('users/', obj);
    }
    await load();
    setModal(null);
  };

  const handleDelete = async (u) => {
    if (!window.confirm(`Biztosan törlöd a(z) "${u.Nev}" felhasználót?`)) return;
    await $delete('users/' + u.id);
    await load();
  };

  const paginationItems = [];
  if (page > 1) paginationItems.push(<Pagination.Prev key="prev" onClick={() => setPage(p => p - 1)} />);
  paginationItems.push(<Pagination.Item key={page} active>{page}</Pagination.Item>);
  if (users?.meta?.next_page) paginationItems.push(<Pagination.Next key="next" onClick={() => setPage(p => p + 1)} />);

  return (
    <>
      <div className="page-card">
        <div className="page-card-header">
          <h2>Felhasználók</h2>
          <Button size="sm" variant="primary" onClick={() => setModal({})}>
            + Új felhasználó
          </Button>
        </div>

        <div className="toolbar">
          <Form.Control
            size="sm"
            placeholder="Szűrés névre…"
            value={filterNev}
            onChange={e => { setFilterNev(e.target.value); setPage(1); }}
          />
          <Form.Control
            size="sm"
            placeholder="Szűrés e-mailre…"
            value={filterEmail}
            onChange={e => { setFilterEmail(e.target.value); setPage(1); }}
          />
        </div>

        <Table className="admin-table" hover responsive>
          <thead>
            <tr>
              <th>Név</th>
              <th>E-mail cím</th>
              <th style={{ width: 80 }}>Műveletek</th>
            </tr>
          </thead>
          <tbody>
            {(users?.result || []).length === 0 ? (
              <tr>
                <td colSpan={3} className="text-center text-muted py-5">
                  Nincsenek felhasználók
                </td>
              </tr>
            ) : (
              users.result.map(u => (
                <tr key={u.id}>
                  <td style={{ fontWeight: 500 }}>{u.Nev}</td>
                  <td>{u.Email}</td>
                  <td>
                    <div className="d-flex gap-2">
                      <BsPencilSquare
                        className="action-icon"
                        onClick={() => setModal(u)}
                        title="Szerkesztés"
                      />
                      <BsFillTrashFill
                        className="action-icon danger"
                        onClick={() => handleDelete(u)}
                        title="Törlés"
                      />
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>

        <div className="table-footer">
          <Pagination size="sm" className="mb-0">{paginationItems}</Pagination>
        </div>
      </div>

      <Modal show={modal !== null} onHide={() => setModal(null)} size="md">
        <Modal.Header closeButton>
          <Modal.Title>{modal?.id ? 'Felhasználó szerkesztése' : 'Új felhasználó létrehozása'}</Modal.Title>
        </Modal.Header>
        <Modal.Body key={modal?.id ?? 'new'}>
          <Form onSubmit={handleSubmit} id="user-form">
            <Form.Group className="mb-3">
              <Form.Label>Név</Form.Label>
              <Form.Control
                id="modal-Nev"
                defaultValue={modal?.Nev}
                placeholder="Teljes név"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>E-mail cím</Form.Label>
              <Form.Control
                id="modal-Email"
                type="email"
                defaultValue={modal?.Email}
                placeholder="pelda@email.com"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{modal?.id ? 'Új jelszó' : 'Jelszó'}</Form.Label>
              <Form.Control
                id="modal-Jelszo"
                type="password"
                placeholder={modal?.id ? 'Hagyd üresen, ha nem változtatod' : 'Jelszó megadása'}
                required={!modal?.id}
              />
              {modal?.id && (
                <Form.Text className="text-muted">
                  Ha üresen hagyod, a jelszó nem változik.
                </Form.Text>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setModal(null)}>Mégse</Button>
          <Button variant="primary" type="submit" form="user-form">Mentés</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default Felhasznalok;
